import CloudOffIcon from "@mui/icons-material/CloudOff";
import CloudQueueIcon from "@mui/icons-material/CloudQueue";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Tooltip from "@mui/material/Tooltip";
import Typography from "@mui/material/Typography";
import { grey } from "@mui/material/colors";
import { type SxProps } from "@mui/material/styles";

import { misc } from "app/themes/colors";
import SaleStatusCell from "features/billing/components/sale-status-cell.component";
import { type Sale } from "services/types/sales.type";
import { formatMoney } from "utils/common";

import DisplayCptCodesItem from "./display-cpt-codes-item.component";
import { getSaleDisplay } from "./util";

type DisplaySaleListItemProps = {
  sale: Sale;
  selected?: boolean;
  onClick?: () => void;
  buttonSx?: SxProps;
  onlyWithClaims?: boolean;
  highlightTotal?: string;
  highlightCptCodes?: string[];
  index: number;
};
export default function DisplaySaleListItem({
  sale,
  selected,
  buttonSx,
  onClick,
  onlyWithClaims,
  highlightTotal,
  highlightCptCodes,
  index
}: DisplaySaleListItemProps) {
  const saleDisplay = getSaleDisplay(sale);
  const saleTotal = formatMoney(Number(sale.total || 0), 2);

  return (
    <ListItem disableGutters key={sale.id}>
      <ListItemButton
        sx={{ ...buttonSx, background: index % 2 ? undefined : grey[50] }}
        selected={selected}
        onClick={onClick}
      >
        <ListItemText
          primary={
            <Typography
              variant="body2"
              sx={{
                maxWidth: "450px",
                lineHeight: 1.3,
                wordWrap: "break-word",
                overflowWrap: "break-word",
                pr: 2
              }}
            >
              <Typography
                variant="body2"
                component="span"
                sx={{ color: grey[700] }}
              >
                Invoice Number:
              </Typography>{" "}
              {saleDisplay}
            </Typography>
          }
          secondary={
            <Typography
              variant="body1"
              mt={0.75}
              sx={{
                backgroundColor:
                  saleTotal === highlightTotal ? misc.warningYellow : undefined
              }}
            >
              <Typography
                variant="body1"
                component="span"
                sx={{
                  color: grey[700]
                }}
              >
                Total:
              </Typography>{" "}
              {saleTotal}
            </Typography>
          }
          sx={{ width: "450px" }}
        />
        {onlyWithClaims && (
          <DisplayCptCodesItem
            highlightCptCodes={highlightCptCodes}
            cptCodes={sale.items
              ?.filter(({ cpt_code }) => Boolean(cpt_code?.code))
              .map(({ cpt_code }) => cpt_code?.code)}
          />
        )}
        {onlyWithClaims && (
          <ListItemIcon>
            {sale.most_recent_hcfa_1500_form ? (
              <Tooltip title="Claim was uploaded">
                <CloudQueueIcon />
              </Tooltip>
            ) : (
              <Tooltip title="Claim was not submitted">
                <CloudOffIcon />
              </Tooltip>
            )}
          </ListItemIcon>
        )}
        <ListItemIcon>
          <SaleStatusCell
            sale={sale}
            readonly
            testId={`sale-cell-${sale.id}-sale-status-cell`}
          />
        </ListItemIcon>
      </ListItemButton>
    </ListItem>
  );
}
